module.exports = __webpack_public_path__ + "img/bj.46b20fac.png";